import { combineReducers } from '@reduxjs/toolkit';

import wsp from 'wave_solder_pallets/store/slice';

const rootReducer = combineReducers({
  wsp,
});

export default rootReducer;
